import { Loader2 } from 'lucide-react';
import { useEffect } from 'react';

import { ZorDocumentsTable } from '@/components/tables/ZorDocumentsTable';
import { toast } from '@/hooks/ui/use-toast';
import { useGetAllZorDocuments } from '@/hooks/zor-document/useGetAllZorDocuments';
import { useZorDocumentStore } from '@/stores/useZorDocumentStore';

export const DocumentTab = () => {
  // custom hooks
  const { zorDocuments, setZorDocuments } = useZorDocumentStore();
  const {
    result: zorDocumentsResult,
    isError: zorDocumentsError,
    isSuccess: zorDocumentsSuccess,
    isLoading: zorDocumentsLoading,
  } = useGetAllZorDocuments();

  // effects
  useEffect(() => {
    if (zorDocumentsError) {
      toast({
        title: 'Something went wrong',
        description: 'Please try again',
        variant: 'destructive',
      });
    }
  }, [zorDocumentsError]);

  useEffect(() => {
    if (zorDocumentsSuccess && zorDocumentsResult?.data) {
      setZorDocuments(zorDocumentsResult.data);
    }
  }, [zorDocumentsSuccess, zorDocumentsResult, setZorDocuments]);

  if (zorDocumentsLoading) {
    return (
      <div className="flex h-full w-full flex-1 items-center justify-center">
        <Loader2 className="size-4 animate-spin" />
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4 border-b border-border pb-2">
        <p className="as-title-01 as-strong text-zinc-700">Documents</p>
      </div>
      {zorDocumentsLoading ? (
        <div className="flex items-center justify-center py-4">
          <Loader2 className="animate-spin" />
        </div>
      ) : (
        <>
          <ZorDocumentsTable data={zorDocuments || []} />
        </>
      )}
    </div>
  );
};
